import { z } from 'zod'

export const feedTargetTypeEnum = z.enum(['ARCHIVED_ROOM', 'JOURNAL_POST', 'BOOK_LIST'])

export const feedCommentSchema = z.object({
  content: z.string().min(1, 'Comment is required').max(200, 'Comment must be 200 characters or less'),
})

export type FeedTargetType = z.infer<typeof feedTargetTypeEnum>
export type FeedCommentInput = z.infer<typeof feedCommentSchema>
